import { ILinkAsButtonProps, ILinkAsLinkProps } from "./types";

export const isLinkAsLinkProps = (
  props: ILinkAsLinkProps | ILinkAsButtonProps
): props is ILinkAsLinkProps => props.as === undefined;
